module.exports = __webpack_public_path__ + "static/img/model1.59920208.png";